(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('HeadendManagePricingDialogController', HeadendManagePricingDialogController);

    HeadendManagePricingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HeadendManagePricing'];

    function HeadendManagePricingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HeadendManagePricing) {
        var vm = this;

        vm.headendManagePricing = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.headendManagePricing.id !== null) {
                HeadendManagePricing.update(vm.headendManagePricing, onSaveSuccess, onSaveError);
            } else {
                HeadendManagePricing.save(vm.headendManagePricing, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('nasracApp:headendManagePricingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
